import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { Card } from '../types/Card';

export type ProductAccount = {
  virtualCard: Card | null;
};
const initialState: ProductAccount = {
  virtualCard: null,
};

const productAccountSlice = createSlice({
  name: 'productAccount',
  initialState,
  reducers: {
    setVirtualCard: (state, action: PayloadAction<Card>) => {
      state.virtualCard = action.payload;
    },
    resetProductAccount: () => initialState,
  },
});

export const { setVirtualCard, resetProductAccount } =
  productAccountSlice.actions;

export default productAccountSlice.reducer;
